import { uiPropsLogin } from 'client/redux/ui/actionCreators';
import { LOGIN_PROPS }  from 'client/redux/auth/constants';

export const loginUiProps = () => dispatch => {
  return dispatch(uiPropsLogin(LOGIN_PROPS));
};
